import fr_CA from './fr'
import es_MX from './es'
import en_US from './en'

// Message schema for each language should match that for English
// See src/boot/plugins.ts for validation
export type MessageSchema = typeof en_US
export type LanguageChoice = 'en_US' | 'fr_CA' | 'es_MX'

export default {
  fr_CA,
  en_US,
  es_MX,
}
